import { render } from "./SliderComponent.vue?vue&type=template&id=533b7624"
import script from "./SliderComponent.vue?vue&type=script&lang=js"
export * from "./SliderComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/home/SliderComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "533b7624"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('533b7624', __exports__)) {
    api.reload('533b7624', __exports__)
  }
  
  module.hot.accept("./SliderComponent.vue?vue&type=template&id=533b7624", () => {
    api.rerender('533b7624', render)
  })

}


export default __exports__